const departmen = ["Department A", "Department B", "Department C"];

export default departmen;
